import React, { useState } from "react";
import { FaTimes, FaSave } from "react-icons/fa";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "../pages/Tasks.css";

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['clean'],
  ],
};
const QUILL_FORMATS = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'color', 'background', 'list', 'bullet', 'indent',
];

const EditTaskModal = ({ task, onClose, onSave, isSubmitting }) => {
  const [form, setForm] = useState({
    title: task.title || "",
    description: task.description || "",
    dueDate: task.dueDate || "",
    priority: task.priority || "Normal",
    labels: task.labels || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title || !form.dueDate) return;
    onSave({ ...task, ...form });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-header">
          <h3>Edit Ticket: {task.ticketNumber || "Draft"}</h3>
          <button className="close-x" onClick={onClose}><FaTimes /></button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-body">
          <div className="input-group">
            <label>Summary</label>
            <input
              name="title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </div>

          <div className="modal-grid">
            <div className="input-group">
              <label>Due Date</label>
              <input
                name="dueDate"
                type="date"
                value={form.dueDate}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-group">
              <label>Priority</label>
              <select name="priority" value={form.priority} onChange={handleChange}>
                <option value="Normal">Normal</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
              </select>
            </div>
          </div>

          <div className="input-group">
            <label>Description / Technical Notes</label>
            <ReactQuill
              className="tasks-quill"
              theme="snow"
              value={form.description}
              onChange={val => setForm(prev => ({ ...prev, description: val }))}
              modules={QUILL_MODULES}
              formats={QUILL_FORMATS}
              placeholder="Technical instructions, acceptance criteria…"
            />
          </div>

          <div className="input-group">
            <label>Labels (Comma separated)</label>
            <input
              name="labels"
              placeholder="e.g. Frontend, Bug, High-Priority"
              value={form.labels}
              onChange={handleChange}
            />
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? "Updating..." : <><FaSave /> Save Changes</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTaskModal;